import { NavLink } from 'react-router-dom';
import SvgIcon from 'components/SvgIcon';
import { ROUTES } from 'app/routes';
import './MobileFooterNav.scss';

type Props = {
  sidebarOpen: boolean;
  toggleSidebar(): void;
};

const JobSeekerMobileFooterNav = ({ sidebarOpen, toggleSidebar }: Props) => {
  const closeIfOpen = () => { if (sidebarOpen) toggleSidebar(); };

  return (
    <nav className="mobile-footer-nav">
      <NavLink exact to={ROUTES.JOB_SEEKER.RESOURCES} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/resources" />
      </NavLink>
      <NavLink exact to={ROUTES.JOB_SEEKER.OPPORTUNITIES} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/job-templates" />
      </NavLink>
      <NavLink exact to={ROUTES.JOB_SEEKER.RESOURCES_PRODUCTS_SERVICES} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/agreement" />
      </NavLink>
      <NavLink exact to={ROUTES.JOB_SEEKER.RESOURCES_EVENTS} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/calendar-menu" />
      </NavLink>
      <NavLink exact to={ROUTES.JOB_SEEKER.JOB_SEEKERS} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/job-seekers" />
      </NavLink>
      <button className={`mobile-footer-nav-item${sidebarOpen ? ' active' : ''}`} onClick={toggleSidebar}>
        <SvgIcon name="sidebar/toggle-sidebar" />
      </button>
    </nav>
  );
};

export default JobSeekerMobileFooterNav;
